import React from 'react';
import {Dropdown, DropdownItem, Heading, Icon} from '@albert-io/atomic';
import {history} from 'client/history';

const MobileNavHeader = ({setTab, title}: {setTab: (tab: string) => void; title: string}) => {
  const assignmentOptions = [
    {value: 'published', label: 'Published'},
    {value: 'drafts', label: 'Draft'}
  ];

  return (
    <div className='assignments-folders_mobile-nav-header'>
      <Heading>{title}</Heading>
      <Dropdown
        closeOnItemClicked
        fillWrapper
        trigger={<Icon icon='caret-down' className='ml-x1 cursor-pointer' />}
      >
        {assignmentOptions.map((option, idx) => (
          <DropdownItem
            key={option.value}
            withBottomBorder={idx === assignmentOptions.length - 1}
            onClick={() => {
              if (setTab) {
                setTab(option.value);
              } else {
                history.pushState(null, `/assignments/#${option.value}`);
              }
            }}
          >
            {option.label} Assignments
          </DropdownItem>
        ))}
        <DropdownItem onClick={() => history.pushState(null, `/saved`)}>Folders</DropdownItem>
      </Dropdown>
    </div>
  );
};

export default MobileNavHeader;
